import { Accordion } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import FaqItem from './FaqItem'
import { trackFaq } from './events'
import classes from './styles.module.scss'

interface FaqProps {
  trackProps: { eventType: string; pageSource: string }
  brandedTitle?: boolean
}

const Faq = ({ trackProps, brandedTitle = true }: FaqProps) => {
  const { t } = useTranslation('@mc/next')

  const trackFaqClick = ([question]: [question: string]) => {
    trackFaq({
      question: t(question),
      ...trackProps,
    })
  }

  return (
    <section data-testid='enterprise-faq'>
      <div className='mc-my-10'>
        <h1
          className={`mc-text-d1 mc-mx-auto mc-mt-10 mc-mb-9 mc-text--center mc-text--uppercase ${
            brandedTitle ? 'mc-text--brand' : ''
          }`}
        >
          {t('faq.title.shortForm')}
        </h1>
        <div className='row no-gutters justify-content-center'>
          <div className='col-12 col-md-8'>
            <Accordion onChange={trackFaqClick}>
              <FaqItem questionNumber={0}>
                <p />
                <ul className={classes.faqList}>
                  <li className='mc-mt-3' />
                </ul>
              </FaqItem>

              <FaqItem questionNumber={1}>
                <p />
                <br />
                <p />
              </FaqItem>

              <FaqItem questionNumber={2}>
                <p />
                <br />
                <p />
              </FaqItem>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Faq
